









import { Component, Prop, Vue } from "vue-property-decorator";
import IModelResponse from "@/shared/interfaces/modules/model-response.interface";
import Model from "@/shared/classes/model";
import __ from "@/shared/helpers/__";
import { GlobalActions } from "@/shared/store/global/global.actions";
import AreYouSureDialog from "@/shared/components/dialogs/AreYouSureDialog.vue";
import FormBase from "@/shared/classes/form/form-base";
import Form from "@/shared/components/form/Form.vue";
import { Positions } from "@/shared/interfaces/classes/form.interfaces";
import Company from "@/shared/modules/company/company.model";
import { CompanyGetters } from "@/shared/store/company/company.getters";
import SearchableField from "@/shared/classes/form/fields/Select/searchable-field";
import Field from "@/shared/classes/form/field";
import { FieldTypes } from "@/shared/components/form/field-types";
import SelectField from "@/shared/classes/form/fields/Select/select-field";
import SelectItem from "@/shared/classes/form/fields/Select/select-item";
import { SnackBarTypes } from "@/shared/helpers/snack-bar.helper";

@Component({
  components: { Form },
  methods: { __ },
})
export default class SelectedRiskModify extends Vue {
  @Prop() selected!: Array<Model<IModelResponse>>
  @Prop() meta!: any
  form!: FormBase
  showForm: boolean = true

  created() {
    this.form = new FormBase()
      .setInline(true)
      .setFields([
        new SearchableField()
          .setKey('responsibleUserUuid')
          .setDense(true)
          .setHideDetails(true)
          .loadItems({
            endpoint: `company/${ this.company.slug }/employees`,
            value: 'uuid',
            title: 'full_name',
            perPage: 20,
          })
          .setTitle(__('company.components.risk-assessments.selected-assign.form.responsible')),
        new Field()
          .setType(FieldTypes.datePicker)
          .setKey('assessmentDate')
          .setTitle(__('company.components.risk-assessments.selected-assign.form.assessment-date'))
          .setDense(true)
          .setMeta({ class: 'ml-2' }),
        new Field()
          .setType(FieldTypes.datePicker)
          .setKey('barrierDeadline')
          .setTitle(__('company.components.risk-assessments.selected-assign.form.barrier-deadline'))
          .setDense(true)
          .setMeta({ class: 'ml-2' }),
        new SelectField()
          .setKey("status")
          .setDense(true)
          .setItems([
            new SelectItem()
              .setValue(1)
              .setTitle(__('company.components.risk-assessments.selected-assign.form.barrier-status-options.in-progress')),
            new SelectItem()
              .setValue(2)
              .setTitle(__('company.components.risk-assessments.selected-assign.form.barrier-status-options.completed')),
          ])
          .setTitle(__('company.components.risk-assessments.selected-assign.form.barrier-status'))
          .setMeta({ class: 'ml-2' })
      ])
      .setBeforeSubmit(this.beforeSubmit)
      .setOnSuccess(this.meta.onSubmit)
      .setOnError(() => {
        this.showForm = false

        this.$nextTick(() => {
          this.showForm = true
        })
      })
      .setSubmit({
        color: 'primary',
        position: Positions.right,
        class: 'ml-2',
        text: __('general.modify'),
      })
  }

  get company(): Company {
    return this.$store.getters[CompanyGetters.getCompany]
  }

  beforeSubmit(): Promise<void> {
    return new Promise((resolve) => {
      this.$store.dispatch(GlobalActions.showDialog, {
        show: true,
        component: AreYouSureDialog,
        meta: {
          title: __('company.views.risk-assessments.assigned.table.actions.update.title'),
          text: __('company.views.risk-assessments.assigned.table.actions.update.text'),
          onYes: () => {
            const hasValue = Object.values(this.form.data).some(element => element !== null && element !== "");;
            if(!hasValue){
              this.$store.dispatch(GlobalActions.showSnackBar, {
              type: SnackBarTypes.error,
              message: __('company.components.risk-assessments.selected-assign.modify-error'),
          })}
            else{
              this.form.data.status=this.form.data.status=="" ? 1:this.form.data.status
              resolve()
            }
          },
        },
      })
    })
  }
}
